import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-tools-line",
    title: "Roof Repair",
    benefit: "Stop leaks and structural damage fast — before small issues spiral into expensive problems.",
    image: "https://public.readdy.ai/ai/img_res/c54f01815e2236293bc725d5f475ae7b.jpg",
  },
  {
    icon: "ri-building-line",
    title: "Roof Replacement",
    benefit: "Full tear-off and premium installation built to last 30+ years through Colorado's harshest weather.",
    image: "https://readdy.ai/api/search-image?query=brand%20new%20complete%20premium%20roof%20replacement%20on%20beautiful%20two%20story%20residential%20home%20in%20Colorado%20Springs%2C%20fresh%20dark%20architectural%20shingles%20perfectly%20installed%2C%20bright%20blue%20sky%2C%20clean%20suburban%20neighborhood%20with%20mountains%20in%20distance%2C%20photorealistic&width=400&height=280&seq=svc11&orientation=landscape",
  },
  {
    icon: "ri-search-eye-line",
    title: "Roof Inspections",
    benefit: "Comprehensive assessments that catch hidden issues early — before they become emergency repairs.",
    image: "https://readdy.ai/api/search-image?query=professional%20roofing%20inspector%20carefully%20examining%20roof%20surface%20details%20with%20professional%20inspection%20tools%2C%20checking%20condition%20of%20dark%20shingles%20on%20residential%20rooftop%2C%20afternoon%20light%2C%20methodical%20detailed%20assessment%2C%20photorealistic&width=400&height=280&seq=svc12&orientation=landscape",
  },
  {
    icon: "ri-thunderstorms-line",
    title: "Storm Damage Repair",
    benefit: "Rapid hail and wind response to seal your home from further damage after severe Colorado weather.",
    image: "https://readdy.ai/api/search-image?query=roofing%20crew%20repairing%20significant%20hail%20storm%20damage%20on%20residential%20home%20in%20Colorado%20neighborhood%2C%20replacing%20broken%20shingles%20after%20severe%20weather%2C%20professional%20team%20working%20efficiently%20on%20roof%20with%20dramatic%20overcast%20sky%2C%20photorealistic&width=400&height=280&seq=svc13&orientation=landscape",
  },
  {
    icon: "ri-drop-line",
    title: "Leak Detection & Fixes",
    benefit: "Precision diagnosis to find the source of water intrusion — then permanent fixes that hold.",
    image: "https://readdy.ai/api/search-image?query=expert%20roofer%20applying%20professional%20waterproof%20flashing%20and%20sealant%20around%20chimney%20base%20and%20roof%20valleys%2C%20stopping%20water%20leak%20permanently%2C%20bright%20sunny%20day%2C%20close%20detail%20of%20skilled%20craftsmanship%2C%20photorealistic%20high%20quality&width=400&height=280&seq=svc14&orientation=landscape",
  },
];

export default function ServicesOverview() {
  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-[#10B981] font-body font-600 text-sm tracking-widest uppercase mb-3 block">
            Our Services
          </span>
          <h2 className="font-headline font-800 text-[#1A1A1A] text-3xl lg:text-4xl xl:text-5xl mb-4 leading-tight max-w-3xl mx-auto">
            Roofing Services Built for Durability, Protection &amp; Peace of Mind
          </h2>
          <p className="text-[#6B7280] font-body text-base lg:text-lg max-w-2xl mx-auto">
            Every service is designed with one goal — protect your home and your investment for decades.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {services.map((service) => (
            <div
              key={service.title}
              className="rounded-lg border border-gray-100 overflow-hidden hover:border-[#10B981]/40 hover:-translate-y-1 transition-all duration-200 group"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-[#10B981]/10">
                    <i className={`${service.icon} text-[#10B981] text-lg`}></i>
                  </div>
                  <h3 className="font-headline font-700 text-[#1A1A1A] text-lg">{service.title}</h3>
                </div>
                <p className="text-[#6B7280] font-body text-sm leading-relaxed mb-4">{service.benefit}</p>
                <Link
                  to="/services/roof-repair"
                  className="inline-flex items-center gap-1.5 text-[#10B981] font-body font-600 text-sm cursor-pointer whitespace-nowrap hover:gap-2.5 transition-all group-hover:text-emerald-600"
                >
                  Learn More
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
              </div>
            </div>
          ))}

          {/* CTA Card */}
          <div className="rounded-lg bg-[#1A1A1A] p-7 flex flex-col justify-between">
            <div>
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-[#10B981]/15 mb-4">
                <i className="ri-question-line text-[#10B981] text-xl"></i>
              </div>
              <h3 className="font-headline font-700 text-white text-xl mb-3">Not Sure What You Need?</h3>
              <p className="text-white/60 font-body text-sm leading-relaxed mb-6">
                We'll inspect your roof at zero cost and tell you exactly what's needed — no pressure, no upsells, just honest answers.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/#contact"
                className="bg-[#10B981] hover:bg-emerald-500 text-white font-body font-700 text-sm py-3.5 rounded-md text-center cursor-pointer whitespace-nowrap transition-colors"
              >
                Get Free Inspection
              </Link>
              <a
                href="tel:+17195550100"
                className="flex items-center justify-center gap-2 text-white/70 hover:text-white font-body text-sm cursor-pointer whitespace-nowrap transition-colors"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-[#10B981] text-sm"></i>
                </div>
                (719) 555-0100
              </a>
            </div>
          </div>
        </div>

        {/* CTA Band after services */}
        <div className="rounded-lg bg-[#F8F9FA] border border-gray-200 p-7 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#10B981]/15 shrink-0">
              <i className="ri-time-line text-[#10B981] text-xl"></i>
            </div>
            <div>
              <p className="font-headline font-700 text-[#1A1A1A] text-base mb-0.5">Urgent roof issue? Don't wait.</p>
              <p className="text-[#6B7280] font-body text-sm">Water damage spreads every hour — call now for same-day service.</p>
            </div>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Link
              to="/#contact"
              className="bg-[#1A1A1A] hover:bg-black text-white font-body font-700 text-sm px-6 py-3 rounded-md cursor-pointer whitespace-nowrap transition-colors"
            >
              Schedule Inspection
            </Link>
            <a
              href="tel:+17195550100"
              className="flex items-center gap-2 text-[#1A1A1A] font-body font-600 text-sm cursor-pointer whitespace-nowrap hover:text-[#10B981] transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-[#10B981] text-sm"></i>
              </div>
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
